export default "__VITE_ASSET__e00a68b7__"